import fetcher from '@/services/fetcher'
import type { PromotionBannerResponse, PromotionsResponse } from '@/types'
import { toPortalUrl } from '@/utils/url-generation-utils'

export async function fetchPromotions() {
  return fetcher.get<PromotionBannerResponse>(toPortalUrl('promotions'), true)
}

/**
 * Fetch promotions including welcome bonus data
 * This endpoint returns both banner promotions and welcome bonus progress
 */
export async function fetchPromotionsWithWelcomeBonus() {
  return fetcher.get<PromotionsResponse>(toPortalUrl('promotions'), true)
}
